import Vue from 'vue'

export default Vue.extend({
  computed: {
    activeTeam (): string {
      return this.$store.direct.state.team.activeTeam
    }
  },
  data: () => ({
    billingSubscribed: false
  }),
  watch: {
    activeTeam () {
      this.subscribe()
    }
  },
  mounted () {
    this.subscribe()
  },
  beforeDestroy () {
    this.unsubscribe()
  },
  methods: {
    subscribe () {
      this.unsubscribe()
      if (this.activeTeam !== '') {
        this.$store.direct.dispatch.team.subscribeBilling(this.activeTeam)
        this.billingSubscribed = true
      }
    },
    unsubscribe () {
      if (this.billingSubscribed) {
        this.$store.direct.dispatch.team.unsubscribeBilling()
        this.billingSubscribed = false
      }
    }
  }
})
